import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGripVertical } from '@fortawesome/free-solid-svg-icons/faGripVertical'
import styles from './Styles/index.module.scss'

interface DraggableContentProps {
    rule: any
    index: number
    rules: any[]
}

export const DraggableContent = (props: DraggableContentProps) => {
    const { rule, index: i, rules } = props

    return (
        <div
            className={`d-flex align-items-center gap-4 ${styles.ruleContent}`}
        >
            <FontAwesomeIcon
                color={'#6c757d'}
                icon={faGripVertical}
            />
            <span className="d-flex flex-column gap-1">
                <span>
                    {rule.rule_name ?? <span className="opacity-75">No name</span>}
                </span>
                <span className={`text-muted ${styles.ruleNumber}`}>
                    {`Rule ${i + 1} of ${rules.length}`}
                </span>
            </span>
        </div>
    )
}
